import { ILoggedCustomer } from "api/types";
import gql from "graphql-tag";
import * as React from "react";
import { Query } from "react-apollo";

export const CustomerDataContext = React.createContext<
  ILoggedCustomer | undefined
>(undefined);

interface IProps {
  children: React.ReactNode;
}

export default ({ children }: IProps) => {
  return (
    <Query
      query={gql`
        {
          loggedCustomer @client {
            authToken
            pointsEarned
            newCustomer
            newLocation
            hashedPin
            skipInterestsStep
            customer {
              phoneNumber
              pointsBalance
              interestIds
              usageTypeIds
            }
          }
        }
      `}
      fetchPolicy="cache-only"
    >
      {props => {
        const { data } = props;

        const interestIds =
          data && data.loggedCustomer
            ? data.loggedCustomer.customer.interestIds
            : [];

        const usageTypeIds =
          data && data.loggedCustomer
            ? data.loggedCustomer.customer.usageTypeIds
            : [];

        return (
          <CustomerDataContext.Provider
            value={(data && data.loggedCustomer) || undefined}
          >
            {children}
          </CustomerDataContext.Provider>
        );
      }}
    </Query>
  );
};



// WEBPACK FOOTER //
// ./src/components/Gates/CustomerDataGate.tsx